<template>
  <div>
    <p class="text-expandable__label" v-b-toggle="contentId">{{ label }}</p>
    <b-collapse :id="contentId">
      <slot></slot>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'text-expandable',
  props: {
    label: {
      type: String,
      required: true,
    },
    contentId: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.text-expandable__label {
  display: inline-block;
  font-weight: 600;
  margin: 0;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    top: calc(50% - 3px);
    right: -20px;
    display: inline-block;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top-color: inherit;
  }
  &.not-collapsed:after {
    top: calc(50% - 8px);
    transform: rotate(180deg);
  }
}
</style>
